/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_404_TitleInputs */

const en_mk_sol_404_title = /** @type {(inputs: Mk_Sol_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That profile does not exist yet`)
};

const id_mk_sol_404_title = /** @type {(inputs: Mk_Sol_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil itu belum ada`)
};

/**
* | output |
* | --- |
* | "That profile does not exist yet" |
*
* @param {Mk_Sol_404_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_404_title = /** @type {((inputs?: Mk_Sol_404_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_404_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_404_title(inputs)
	return en_mk_sol_404_title(inputs)
});